import { createContext, useContext } from "react";
export const ThemeContext = createContext(null);
export const useTheme = () => {
    const context = useContext(ThemeContext);
    if (!context)
        throw new Error("OddboxUIThemeProvider is missing!");
    return context;
};
//# sourceMappingURL=ThemeContext.js.map